/*jslint browser: true, plusplus: true*/

export const sb_delay = (function () {
  var timer: ReturnType<typeof setTimeout>;
  return function (callback: () => void, ms: number) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
